












































import Vue, { PropType } from "vue";
import { ModRaid } from "models/Raid";
import { Spieler } from "models/Spieler";

export default Vue.extend({
	name: "ModRaidOverviewComp",
	data: () => ({
		open: false,
	}),
	props: {
		raids: Array as PropType<ModRaid[]>,
	},
	computed: {},
	methods: {
		getLeader: function(raid: ModRaid): Spieler[] {
			return raid.spieler.filter(s => s.role === 2);
		},
		getLieutenants: function(raid: ModRaid): Spieler[] {
			return raid.spieler.filter(s => s.role === 1);
		},
		hasLieutenants: function(raid: ModRaid): boolean {
			return raid.spieler.filter(s => s.role === 1).length > 0;
		},
	},
});
